var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaintBrushNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 504.113 504.113",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#D3C5CC"
    },
    cx: 274.513,
    cy: 428.857,
    rx: 229.6,
    ry: 13.6
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF3388"
    },
    d: "M341.713,232.057c35.2,35.2,16,152.8-71.2,182.4c-63.2,21.6-255.2,32.8-267.2-6.4 c-14.4-48,12.8,85.6,188.8-154.4C231.313,199.257,306.513,196.857,341.713,232.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BC086B"
    },
    d: "M336.113,244.057c35.2,35.2,21.6,140.8-66.4,170.4c-63.2,21.6-255.2,32.8-267.2-6.4 c-14.4-48,51.2,110.4,227.2-130.4C269.713,224.057,300.913,208.857,336.113,244.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0005F"
    },
    d: "M336.113,244.057c35.2,35.2,21.6,140.8-66.4,170.4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E9BCC"
    },
    d: "M500.113,61.657h-67.2l-108.8,124c-7.2,7.2-7.2,19.2,0,26.4l28.8,29.6c7.2,7.2,19.2,7.2,26.4,0 l120.8-107.2V61.657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#207EB7"
    },
    d: "M325.713,215.257l28,25.6c7.2,7.2,19.2,7.2,26.4,0.8l120-106.4v-73.6h-64"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0E6BAA"
    },
    d: "M353.713,240.057c7.2,7.2,19.2,8,26.4,0.8l120-106.4v-72.8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.049,
    y: 200.341,
    transform: "matrix(-0.7072 -0.707 0.707 -0.7072 430.1652 622.8253)",
    style: {
      fill: "#F4CD27"
    },
    width: 79.999,
    height: 44
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.327,
    y: 206.306,
    transform: "matrix(-0.707 -0.7072 0.7072 -0.707 435.1849 636.9079)",
    style: {
      fill: "#EDB811"
    },
    width: 62.399,
    height: 44
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintBrushNew);
export default __webpack_public_path__ + "static/media/paintBrush-new.ebaff65f4247b2233731c31a4ffe6934.svg";
export { ForwardRef as ReactComponent };